module.exports = __webpack_public_path__ + "img/rocket.c55aefe2.svg";